export default __webpack_public_path__ + "0fac38b7b01c72463d8495dfadd103f0.woff2";